import React from 'react';
import {
    PropsShell,
    PropsNotFound,
    PropsCommonFields,
    PropsSection,
    PropsField,
    PropsOptionsEditor,
    PropsRequiredAndMeta,
    useQuestionProperties,
} from './QuestionPropertiesShared';

const DropdownBlockProperties = ({ questionId }) => {
    const { question, localName, nameError, handleUpdate, handleNameChange } =
        useQuestionProperties(questionId);

    if (!question) return <PropsNotFound />;

    return (
        <PropsShell typeLabel="Dropdown" typeIcon="bi-menu-button-wide">
            <PropsCommonFields
                localName={localName}
                nameError={nameError}
                onNameChange={handleNameChange}
                title={question.title}
                description={question.description}
                onTitleChange={(value) => handleUpdate('title', value)}
                onDescriptionChange={(value) => handleUpdate('description', value)}
            />

            <PropsSection title="Input">
                <PropsField label="Placeholder" hint="Shown when no option is selected">
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        value={question.placeholder || ''}
                        onChange={(e) => handleUpdate('placeholder', e.target.value)}
                    />
                </PropsField>
            </PropsSection>

            <PropsOptionsEditor
                options={question.options}
                onChange={(options) => handleUpdate('options', options)}
            />

            <PropsRequiredAndMeta
                required={question.required}
                onRequiredChange={(value) => handleUpdate('required', value)}
                questionId={questionId}
            />
        </PropsShell>
    );
};

export default DropdownBlockProperties;
